import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, Input } from '@angular/core';
import { OpsEvent } from '@models/ops-event/ops-event';
import { Participation } from '@models/ops-event/participation';
import { Profile } from '@models/profile/profile';
import { Store } from '@ngxs/store';
import { Participate } from '@store/company/custom-forms/custom-forms.actions';

@Component({
  selector: 'company-inmail-custom-form',
  templateUrl: './inmail-custom-form.component.html',
  styleUrls: ['./inmail-custom-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InmailCustomFormComponent {
  @HostBinding('class.theme-events') theme = true;

  @Input() profile: Profile;
  @Input() event: OpsEvent;

  participationSent: boolean;
  sendingParticipation: boolean;

  constructor(private readonly cdr: ChangeDetectorRef, private readonly store: Store) {}

  doParticipate([eventId, participation]: [string, Participation]): void {
    this.sendingParticipation = true;

    this.store.dispatch(new Participate(eventId, participation)).subscribe(() => {
      this.sendingParticipation = false;
      this.participationSent = true;
      this.cdr.markForCheck();
    });
  }

  doClose(): void {
    this.sendingParticipation = false;
    this.participationSent = false;
  }
}
